import { createContext } from 'react';
export var OptimizelyContext = /*#__PURE__*/createContext(undefined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/externals/PaymentMethods/OptimizelyContext.js
// module id = 4647
// module chunks = 11